/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import { message, Tabs } from "antd";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import ViewAllBookingTable from "./AllBookingTable";
import ViewRetailBookingTable from "./ViewRetailBooking";

import ViewManifestTable from "./ViewManifest";
import ViewRetailDiscount from "./viewRetailDiscount";
import { clearGetManifestTable } from "../../../actionsMethods/manifestMethods";
import constants from "../../../constants/constants";
import {
  capitalise,
  firstLetterCapitaliseStr,
  getCurretRole,
  dateFormat_ymd,
  capitaliseWithHyphen,
} from "../../../utils";
import API from "../../../api";
import urls from "../../../api/urls";
import axios from "axios";
import moment from "moment";
import useCustomNavigate from "../../../components/customNavigationHook";
import { convertCurrentToPrevBookingData } from "../../../utils/bookingDataConverter";
import ViewBookingListing from "./ViewBookingListing";

const ViewBookingTabs = () => {
  const history = useLocation();
  const dispatch = useDispatch();
  const [key, setKey] = useState("1");
  const getData = JSON.parse(localStorage.getItem("manifestedId"));
  const navigate = useCustomNavigate();
  const isClientAdmin = getCurretRole();
  const [user_Info, setUser_Info] = useState(
    JSON.parse(localStorage.getItem("userinfo"))
  );
  const [totalCount, setTotalCount] = useState(0);

  let data = [1000221, 4969, 4967, 4967, 4970, "MAHARASHTRA"];

  const enableDiscount =
    data.includes(user_Info?.premiseId) ||
    data.includes(user_Info?.state?.toUpperCase());

  const {
    NBA_EXPORT_BOOKING_DATA,
    GET_ALL_STAFF,
    GET_SINGEL_DOCUMENT_DETAILS_AWB_BE,
  } = urls;

  useEffect(() => {
    if (history?.state?.currentTab) {
      setKey(history?.state?.currentTab);
    }
  }, [history]);

  const onChange = (key) => {
    if (+key === 2) {
      dispatch(clearGetManifestTable());
    }
    // navigate("/", { currentTab: key });

    setKey(key);

    navigate(location.pathname, {
      state: { ...history.state, currentTab: key },
      replace: true, // This prevents re-navigation but updates state
    });

    localStorage.removeItem("manifestedId");
  };

  useEffect(() => {
    if (history?.pathname === "/viewBooking" && getData) {
      setKey("3");
    } else {
      setKey("1");
    }
  }, [history]);

  const [userList, setUserList] = useState([]);
  React.useEffect(() => {
    getUsers();
  }, []);

  const getUsers = async () => {
    let url = `${GET_ALL_STAFF}?pageNum=${0}&pageSize=${100}`;

    let response = await API.Api(url).getWithUserNPremiseHeader();

    if (response?.status) {
      const data = response?.response?.data?.data;
      setUserList(
        data?.map((item, idx) => ({
          value: item?.staffId,
          label: item?.firstName,
          text: capitaliseWithHyphen(item?.firstName),
          key: item?.staffId,
        }))
      );
    } else {
      return;
    }
  };

  const selectedCompany =
    JSON.parse(localStorage.getItem("selectedCompany")) || null;

  const exportData = async (filterData) => {
    let url = `${NBA_EXPORT_BOOKING_DATA}`;

    if (selectedCompany?.key) {
      url += `?companyId=${selectedCompany?.key}`;
    }

    if (filterData?.userSeleted) {
      let temp = userList.find((val) => val.key == filterData?.userSeleted);
      url += `&usernames=${temp?.text}`;
    }

    if (filterData?.startDate) {
      const start = moment(filterData.startDate, "DD-MM-YYYY").format(
        "YYYY-MM-DD"
      );
      const end = moment(filterData.endDate, "DD-MM-YYYY").format("YYYY-MM-DD");

      url += `&createdAtStart=${start}&createdAtEnd=${end}`;
    }

    if (filterData?.bookingType) {
      url += `&bookingType=${
        filterData?.bookingType == "retail" ? "retail" : "credit"
      } `;
    }
    if (filterData?.client) {
      url += `&clientId=${filterData?.client}`;
    }

    if (filterData?.status) {
      url += `&status=${
        filterData?.status?.toLowerCase() == "booked" ? "BOOKED" : "DELIVERED"
      }`;
    }

    if (filterData?.docType) {
      url += `&shipmentType=${filterData?.docType?.toUpperCase()}`;
    }

    if (filterData?.serviceType) {
      const serviceType = filterData?.serviceType?.toLowerCase();

      let deliveryPromise = "";

      if (serviceType?.includes("vayu")) {
        deliveryPromise = serviceType?.includes("pro")
          ? "vayuQuickPro"
          : filterData?.serviceType;
      } else if (serviceType?.toLowerCase()?.includes("value plus")) {
        deliveryPromise = "valuePlus";
      } else if (serviceType?.toLowerCase()?.includes("fast track")) {
        deliveryPromise = "Fastrack";
      } else {
        deliveryPromise = firstLetterCapitaliseStr(filterData.serviceType);
      }

      url += `&deliveryPromise=${deliveryPromise}`;
    }

    if (filterData?.travelBy) {
      url += `&travelBy=${firstLetterCapitaliseStr(filterData?.travelBy)}`;
    }

    const response = await axios.get(url, {
      responseType: "blob",
    });

    const downLinkurl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = downLinkurl;
    link.setAttribute("download", "shipments.xlsx");
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const currentEnv = process.env.REACT_APP_ENV;

  function convertNewToOldData(newData) {
    if (!newData?.data?.items) return null;

    return {
      surfaceShipmentNo: null,
      airShipmentNo: null,
      surfaceShipmentWeight: null,
      atrShipmentWeight: null,
      surfaceVolWeight: null,
      airVolWeight: null,
      totalCount: newData.data.count,
      totalPages: newData.data.totalPages,
      viewBookings: newData.data.items.map((item) => ({
        awbNumber: parseInt(item.documentNo),
        bookingTime: item.createdAt,
        bookingType: item.bookingType,
        bookingStatus: item.status,
        serviceType: item.deliveryPromise,
        weight: item.dwsWeight,
        travelBy: item.travelBy,
        location: null,
        volumetricWeight: +item.volumentricWeight,
        type: item.shipmentType,
        toCenter: item.receiverAddress?.city || null,
        senderName: item.pickupAddress?.name || null,
        receiverName: item.receiverAddress?.name || null,
        clientName: null,
        userId: null,
        userName: item.username,
        length: parseFloat(item.dwsLength) || 0,
        width: 0,
        height: parseFloat(item.dwsHeight) || 0,
        childCount: item.childCount,
        senderMobileNumber: parseInt(item.pickupAddress?.phone) || null,
        receiverMobileNumber: parseInt(item.receiverAddress?.phone) || null,
        frightCharges: null,
        packegingCharge: 0,
        totalCharge: item?.charges?.totalCharge || null,
        isAudited: null,
        auditedWeight: parseFloat(item.auditedWeight) || null,
        invoiceNumber: item.metadata?.invoiceNo,
        modeOfPayment: item?.charges?.mode || null,
        refDocumentNo: item?.metadata?.refDocumentNo || "",
      })),
    };
  }

  const [loading, setLoading] = useState(false);

  const printerLabelCallBack = async (params) => {
    setLoading(true);
    let url = `${GET_SINGEL_DOCUMENT_DETAILS_AWB_BE + +params}`;

    let response = await API.Api(url).getWithAllHeaders();
    if (response?.status) {
      setLoading(false);
      let extract = response?.response?.data?.data?.items;
      let convert = convertCurrentToPrevBookingData(extract);
      return convert;
      // setDocumentDetails(convert);
    } else {
      setLoading(false);
      message.error(
        response?.response?.data?.message || "Internal server error."
      );
    }
  };

  const printPDFLabel = async (data) => {
    let temp = await printerLabelCallBack(data?.awbNumber);

    const serviceMap = {
      "FAST TRACK": "FST",
      FASTRACK: "FST",

      STANDARD: "STD",
      "VALUE PLUS": "VPLUS",
      VALUEPLUS: "VPLUS",
      VAYUQUICK: "VQK",
      VAYUQUICK_PRO: "VQ PRO",
      VAYUQUICKPRO: "VQ PRO",
    };

    const rawService = temp?.serviceDetails?.service?.toUpperCase() || "";

    const speed = serviceMap[rawService] || rawService;

    // console.log(temp, "temp");
    // console.log(speed, "speed");
    // console.log(
    //   temp?.shipmentDetails?.travelBy?.toUpperCase() || "",
    //   "travelBy"
    // );

    // console.log(rawService, "rawService");

    const output = {
      labels: [
        {
          mode: temp?.shipmentDetails?.travelBy?.toUpperCase() || "", // e.g., "SURFACE"
          type: temp?.shipmentDetails?.type?.toUpperCase() || "", // e.g., "DOX"
          speed: speed || "", // e.g., "VAYUQUICK" (replace logic if needed)
          qty: `${temp?.childShipmentDetails?.length || 0}/1`, // Using actual child count
          qr_code: temp?.awbNumber.toString(),
          awb_number: temp?.awbNumber.toString(),
          barcode_awb_number: temp?.awbNumber.toString(),
          to_deliver: temp?.addressDetails?.receiverName || "",
          to_mobile:
            temp.addressDetails?.receiverMobileNumber?.toString() || "",
          to_pincode: temp?.addressDetails?.receiverPincode?.toString() || "",
          to_city: temp?.addressDetails?.receiverCity || "",
          to_address: `${temp?.addressDetails?.receiverAddressLine1 || ""}, ${
            temp.addressDetails?.receiverCity || ""
          }, ${temp.addressDetails?.receiverState || ""}`,
          from_address: `${temp?.addressDetails?.senderAddressLine1 || ""}, ${
            temp?.addressDetails?.senderCity || ""
          }, ${temp?.addressDetails?.senderState || ""}`,
          from_mobile:
            temp?.addressDetails?.senderMobileNumber?.toString() || "",
        },
      ],
    };

    const url = "https://devapis.delcaper.com/gopdf/pdf/nba_label_4x6";

    try {
      setLoading(true);

      const response = await axios.post(url, output, {
        headers: {
          "Content-Type": "application/json",
        },
        responseType: "blob",
      });

      setLoading(false);
      const blob = new Blob([response.data], { type: "application/pdf" });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${data?.awbNumber + ".pdf"}`; // You can customize the filename
      link.click();
    } catch (error) {
      setLoading(false);
      message.error(error?.response?.data?.message || "Internal server error.");
    }
  };

  return (
    <div className="booking-table-tabs">
      <Tabs
        defaultActiveKey={"1"}
        // className="booking-table-tabs"
        activeKey={history?.state?.currentTab || key}
        items={[
          {
            label: "View Credit Booking",
            key: "1",
            children: (
              <ViewAllBookingTable
                exportData={exportData}
                userList={userList}
                convertNewToOldData={convertNewToOldData}
                printPDFLabel={printPDFLabel}
                loading={loading}
                setLoading={setLoading}
              />
            ),
          },
          !isClientAdmin && {
            label: "View Retail Booking",
            key: "2",
            children: (
              <ViewRetailBookingTable
                exportData={exportData}
                userList={userList}
                convertNewToOldData={convertNewToOldData}
                printPDFLabel={printPDFLabel}
                loading={loading}
                setLoading={setLoading}
              />
            ),
          },

          !isClientAdmin && {
            label: "View Manifest",
            key: "3",
            children: <ViewManifestTable />,
          },
          enableDiscount && {
            label: "View Retail Discount",
            key: "4",
            children: <ViewRetailDiscount />,
          },
          {
            label: "OCR Bookings",
            key: "5",
            children: (
              <ViewBookingListing
                listingType="OCR"
                exportData={exportData}
                userList={userList}
                convertNewToOldData={convertNewToOldData}
                printPDFLabel={printPDFLabel}
                loading={loading}
                setLoading={setLoading}
              />
            ),
          },
          {
            label: `API Bookings ${totalCount ? `(${totalCount})` : ""}`,
            key: "6",
            children: (
              <ViewBookingListing
                listingType="API"
                exportData={exportData}
                userList={userList}
                convertNewToOldData={convertNewToOldData}
                printPDFLabel={printPDFLabel}
                loading={loading}
                setLoading={setLoading}
                setTotalCount={setTotalCount}
              />
            ),
          },
        ]}
        onChange={onChange}
      />
    </div>
  );
};

export default ViewBookingTabs;
